import { type } from '@mews/framework';
import ApiComponent from '../apiComponent';
import createRequest from './misc/createRequest';

const BASE_URL = '/notifications';

export default function NotificationComponent(apiComponent: $TSFixMe) {
    type.check(apiComponent, ApiComponent);
    const request = createRequest(apiComponent.request, BASE_URL);

    return type.create(NotificationComponent, {
        getNotifications() {
            return request('/getAllUpdated');
        },

        getNotificationByIds(ids: $TSFixMe) {
            return request('/getAllByIds', { NotificationIds: ids });
        },

        updateState(notificationIds: $TSFixMe, state: $TSFixMe, profileId: $TSFixMe) {
            return request('/updateState', { notificationIds, state: state.value, profileId });
        },
    });
}
